import React from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import NutritionItem from "../NutritionItem/NutritionItem";

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .item {
    margin-bottom: 13px;
  }
`;

const MacronutrientsTotal = (props) => {
  const {
    calories,
    totalFats,
    longChainFats,
    mediumChainFats,
    isModal,
    isFastingDay,
  } = props;

  const { t } = useTranslation();

  return (
    <ComponentWrapper data-testid="macronutrients-total">
      <NutritionItem
        className="item"
        isFastingDay={isFastingDay}
        isModal={isModal}
        value={calories || "0.00 kcal"}
        title={t("appText.dietDiary.totalCalories")}
        backgroundColor={props.theme?.hailstone}
        titleColor={props.theme?.nero}
      />
      <NutritionItem
        className="item"
        isFastingDay={isFastingDay}
        isModal={isModal}
        value={totalFats || "0.00 g"}
        title={t("appText.dietDiary.nutritionTable.totalFat")}
        backgroundColor={props.theme?.blueMagenta2}
        titleColor={props.theme?.white}
      />
      <NutritionItem
        className="item"
        isFastingDay={isFastingDay}
        isModal={isModal}
        value={longChainFats || "0.00 g"}
        title={t("appText.dietDiary.longChainFats")}
        backgroundColor={props.theme?.blueMagentaMediumLight}
        titleColor={props.theme?.darkShadeGray}
      />
      <NutritionItem
        className="item"
        isFastingDay={isFastingDay}
        isModal={isModal}
        value={mediumChainFats || "0.00 g"}
        title={t("appText.dietDiary.mediumChainFats")}
        backgroundColor={props.theme?.blueMagentaVeryLight}
        titleColor={props.theme?.darkShadeGray}
      />
    </ComponentWrapper>
  );
};

export default withTheme(MacronutrientsTotal);
